import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../commons/cart.service';
import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';
import { ScrollService } from '../commons/scroll.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Param, } from '../commons/models';

@Component({
  template: require('./slide-parameter.component.html')
})


export class SlideParameterComponent implements OnInit {

  public table: string;
  public parametersSlide: Param[] = [];
  public parameter: string;

  constructor(
    private config: ConfigService,
    public cartService: CartService,
    public session: SessionService,
    private router: Router,
    private scroll: ScrollService,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.cartService.cartCheckProducts();

    if (!this.cartService.cart.currentCartProduct.photoOriginal) {
      //console.log('no photoOriginal - redirect upload-photo');
      this.router.navigate(['/upload-photo']);
    }

    this.activatedRoute.params.subscribe((params: Params) => {

      this.table = 'Navbar' + this.router.url.split('/').reverse()[0];
      let thisButton = this.config.btnToggles.filter(r => r.isParameter && r.text === this.table)[0];

      this.parameter = thisButton.text;

      if (this.session.params && this.session.params.length !== 0) {
        this.parametersSlide = this.session.params.filter(r => r.table === this.table);
        //console.log('this.parametersSlide');
        //console.log(this.parametersSlide);
      }
    });
  }




}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/slide-parameter.component.ts